import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { WithClassName } from '@types';

export const Heading1 = ({
  children,
  className,
}: WithClassName & PropsWithChildren) => (
  <h1
    className={classNames(
      'font-title text-4xl text-accent lowercase max-tablet:text-center',
      className,
    )}
  >
    {children}
  </h1>
);

export const Heading2 = ({
  children,
  className,
}: WithClassName & PropsWithChildren) => (
  <h2
    className={classNames(
      'font-title text-xl lowercase max-tablet:text-center',
      className,
    )}
  >
    {children}
  </h2>
);

interface ButtonProps {
  onClick: () => void;
  selected?: boolean;
}

export const Button = ({
  children,
  className,
  onClick,
  selected,
}: ButtonProps & WithClassName & PropsWithChildren) => (
  <button
    className={classNames(
      'transition-colors cursor-pointer hover:text-accent',
      selected ? 'border-b hover:border-accent' : 'border-b border-transparent',
      className,
    )}
    onClick={onClick}
  >
    {children}
  </button>
);
